/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetBoughtItemsFeedbackModalQueryVariables = Types.Exact<{
  skuId: Types.Scalars["ID"]["input"];
  orderId: Types.Scalars["ID"]["input"];
}>;

export type GetBoughtItemsFeedbackModalQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    wardrobe: {
      __typename?: "WardrobeContentModule";
      boughtModule: {
        __typename?: "WardrobeBoughtModule";
        boughtItemFeedbackModal: {
          __typename?: "WardrobeBoughtItemFeedbackModal";
          heading: string;
          subheading: string;
          returnHeading: string;
          returnBody: string;
          boughtItem: {
            __typename?: "KeptItem";
            eligibleForReturn: boolean;
            orderType: string;
            shopProduct?: {
              __typename?: "ShopProduct";
              name: string;
              brand: { __typename?: "Brand"; name: string };
            } | null;
            variant: {
              __typename?: "ShopProductVariant";
              size: { __typename?: "Size"; name: string };
            };
          };
          feedbackQuestions: {
            __typename?: "KeptItemFeedbackQuestionSet";
            questionSetId: string;
            questions: Array<
              | {
                  __typename: "KeptItemFeedbackFreeformQuestion";
                  label: string;
                  questionId: string;
                  value?: string | null;
                  secondaryLabel?: string | null;
                }
              | {
                  __typename: "KeptItemFeedbackMultipleChoiceQuestion";
                  label: string;
                  questionId: string;
                  options: Array<{
                    __typename?: "KeptItemFeedbackMultipleChoiceQuestionOption";
                    label: string;
                    pointValue: string;
                    questionId: string;
                    value: boolean;
                  }>;
                }
            >;
          };
        };
      };
    };
  } | null;
};

export type KeptItemFeedbackQuestionsFragment = {
  __typename?: "KeptItemFeedbackQuestionSet";
  questionSetId: string;
  questions: Array<
    | {
        __typename: "KeptItemFeedbackFreeformQuestion";
        label: string;
        questionId: string;
        value?: string | null;
        secondaryLabel?: string | null;
      }
    | {
        __typename: "KeptItemFeedbackMultipleChoiceQuestion";
        label: string;
        questionId: string;
        options: Array<{
          __typename?: "KeptItemFeedbackMultipleChoiceQuestionOption";
          label: string;
          pointValue: string;
          questionId: string;
          value: boolean;
        }>;
      }
  >;
};

export type KeptItemFeedbackMultipleChoiceQuestionFragment = {
  __typename?: "KeptItemFeedbackMultipleChoiceQuestion";
  questionId: string;
  label: string;
  options: Array<{
    __typename?: "KeptItemFeedbackMultipleChoiceQuestionOption";
    label: string;
    pointValue: string;
    questionId: string;
    value: boolean;
  }>;
};

export type KeptItemFeedbackFreeformQuestionFragment = {
  __typename?: "KeptItemFeedbackFreeformQuestion";
  questionId: string;
  label: string;
  value?: string | null;
  secondaryLabel?: string | null;
};

export type OptionFragment = {
  __typename?: "KeptItemFeedbackMultipleChoiceQuestionOption";
  label: string;
  pointValue: string;
  questionId: string;
  value: boolean;
};

export const OptionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Option" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestionOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "pointValue" } },
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const KeptItemFeedbackMultipleChoiceQuestionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "options" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Option" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Option" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestionOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "pointValue" } },
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const KeptItemFeedbackFreeformQuestionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryLabel" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const KeptItemFeedbackQuestionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItemFeedbackQuestions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackQuestionSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "questions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "questionId" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "questionSetId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Option" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestionOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "pointValue" } },
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "options" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Option" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryLabel" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetBoughtItemsFeedbackModalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getBoughtItemsFeedbackModal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "skuId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "wardrobe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boughtModule" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "boughtItemFeedbackModal" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "skuId" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "skuId" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "orderId" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "orderId" },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "boughtItem" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "eligibleForReturn" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "shopProduct" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "brand" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "name" },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "name" },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "variant" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "size" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "name" },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "orderType" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "feedbackQuestions" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "KeptItemFeedbackQuestions",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "heading" } },
                                  { kind: "Field", name: { kind: "Name", value: "subheading" } },
                                  { kind: "Field", name: { kind: "Name", value: "returnHeading" } },
                                  { kind: "Field", name: { kind: "Name", value: "returnBody" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Option" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestionOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "pointValue" } },
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "options" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "Option" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "questionId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryLabel" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItemFeedbackQuestions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeptItemFeedbackQuestionSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "questions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "questionId" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "KeptItemFeedbackMultipleChoiceQuestion" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "KeptItemFeedbackFreeformQuestion" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "questionSetId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetBoughtItemsFeedbackModalQuery__
 *
 * To run a query within a React component, call `useGetBoughtItemsFeedbackModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtItemsFeedbackModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtItemsFeedbackModalQuery({
 *   variables: {
 *      skuId: // value for 'skuId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetBoughtItemsFeedbackModalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBoughtItemsFeedbackModalQuery,
    GetBoughtItemsFeedbackModalQueryVariables
  > &
    ({ variables: GetBoughtItemsFeedbackModalQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBoughtItemsFeedbackModalQuery,
    GetBoughtItemsFeedbackModalQueryVariables
  >(GetBoughtItemsFeedbackModalDocument, options);
}
export function useGetBoughtItemsFeedbackModalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBoughtItemsFeedbackModalQuery,
    GetBoughtItemsFeedbackModalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBoughtItemsFeedbackModalQuery,
    GetBoughtItemsFeedbackModalQueryVariables
  >(GetBoughtItemsFeedbackModalDocument, options);
}
// @ts-ignore
export function useGetBoughtItemsFeedbackModalSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBoughtItemsFeedbackModalQuery,
    GetBoughtItemsFeedbackModalQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetBoughtItemsFeedbackModalQuery,
  GetBoughtItemsFeedbackModalQueryVariables
>;
export function useGetBoughtItemsFeedbackModalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBoughtItemsFeedbackModalQuery,
        GetBoughtItemsFeedbackModalQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetBoughtItemsFeedbackModalQuery | undefined,
  GetBoughtItemsFeedbackModalQueryVariables
>;
export function useGetBoughtItemsFeedbackModalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBoughtItemsFeedbackModalQuery,
        GetBoughtItemsFeedbackModalQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetBoughtItemsFeedbackModalQuery,
    GetBoughtItemsFeedbackModalQueryVariables
  >(GetBoughtItemsFeedbackModalDocument, options);
}
export type GetBoughtItemsFeedbackModalQueryHookResult = ReturnType<
  typeof useGetBoughtItemsFeedbackModalQuery
>;
export type GetBoughtItemsFeedbackModalLazyQueryHookResult = ReturnType<
  typeof useGetBoughtItemsFeedbackModalLazyQuery
>;
export type GetBoughtItemsFeedbackModalSuspenseQueryHookResult = ReturnType<
  typeof useGetBoughtItemsFeedbackModalSuspenseQuery
>;
export type GetBoughtItemsFeedbackModalQueryResult = Apollo.QueryResult<
  GetBoughtItemsFeedbackModalQuery,
  GetBoughtItemsFeedbackModalQueryVariables
>;
